module.exports = __webpack_public_path__ + "img/IMG_2333.b3988285.jpg";